<mat-dialog-content>
  <app-loader-content [text]="data.text" [title]="data.title" [isLoader]="true"></app-loader-content>
</mat-dialog-content>
